import * as React from 'react';
// import styles from './index.less';
import { CSSProperties } from 'react';

interface FFilterProps {
  className?: string;
  style?: CSSProperties;

  onClick?(): void;
}

function FFilter({ className, ...props }: FFilterProps) {
  return <i className={['freelog', 'fl-icon-icon_shaixuan', className].join(' ')} {...props} />;
}

export default FFilter;
